export const SC_SET_ACTIVE_DATE = 'SC_SET_ACTIVE_DATE';
export const SC_SET_CALENDAR_VISIBILITY = 'SC_SET_CALENDAR_VISIBILITY';
export const SC_SET_DISPLAYED_TASKS_IDS = 'SC_SET_DISPLAYED_TASKS_IDS';
export const SC_SET_EXPAND_ALL = 'SC_SET_EXPAND_ALL';
export const SC_SET_FETCHING_FLAG = 'SC_SET_FETCHING_FLAG';
export const SC_SET_FILTERS_VISIBILITY = 'SC_SET_FILTERS_VISIBILITY';
export const SC_SET_MODE = 'SC_SET_MODE';
export const SC_SET_ORGANIZE_MODE_FLAG = 'SC_SET_ORGANIZE_MODE_FLAG';
export const SC_SET_SCHEDULE_MOUNTED_FLAG = 'SC_SET_SCHEDULE_MOUNTED_FLAG';
export const SC_SET_SORTING_OPTION = 'SC_SET_SORTING_OPTION';
export const SC_SET_SUBJECT = 'SC_SET_SUBJECT';
export const SC_SET_DISPLAYED_SCHEDULE_TYPE = 'SC_SET_DISPLAYED_SCHEDULE_TYPE';
export const SC_SET_TYPE = 'SC_SET_TYPE';
export const SC_UPDATE_SEARCH_QUERY = 'SC_UPDATE_SEARCH_QUERY';
export const SC_PAGINATION_PREV_PAGE = 'SC_PAGINATION_PREV_PAGE';
export const SC_PAGINATION_NEXT_PAGE = 'SC_PAGINATION_NEXT_PAGE';
